import { LayersControl, useMapEvents } from 'react-leaflet'

const OverlayLayers = ({ overlayLayers, setOverlayLayers }) => {
  const map = useMapEvents({
    overlayadd: (e) => {
      window.localStorage.setItem(`${e.name.replace(' ', '_')}_overlay`, true)
      setOverlayLayers((prev) =>
        prev.map((overlay) => (overlay.name === e.name ? { ...overlay, checked: true } : overlay)),
      )
    },
    overlayremove: (e) => {
      window.localStorage.removeItem(`${e.name.replace(' ', '_')}_overlay`)
      setOverlayLayers((prev) =>
        prev.map((overlay) => (overlay.name === e.name ? { ...overlay, checked: false } : overlay)),
      )
    },
  })
  return (
    <LayersControl position="topleft">
      <LayersControl.BaseLayer checked name="OpenStreetMap" />

      {/* Base Layer: Traficom S-57 WMS */}
      {overlayLayers.map((overlay) => (
        <LayersControl.Overlay key={overlay.tag} name={overlay.name} checked={overlay.checked}>
          {overlay.layer}
        </LayersControl.Overlay>
      ))}
    </LayersControl>
  )
}

export default OverlayLayers
